import $ from 'jquery';

$('[data-select-link]').each(function() {
  const $this = $(this);
  const $parentForm = $this.parents('form');

  $this.on('change', function() {
    const $selectedOption = $this.find('option:selected');
    // $parentForm.attr('action', $selectedOption.attr('data-select-url'));
    // $parentForm.submit();
    let target = $selectedOption.attr('data-select-url');
    window.location.hash = target;
  });
});